// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const en = {
  demo: {
    title: `English`,
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
  GoogleAuth: {
    RecoveryCode: 'Recovery Code',
    loginGoogleAuth: 'Login with Google Authenticator Code',
    loginRecovery: 'Login with Recovery Code',
    scan: 'Scan this QR code with Google Authenticator',
    enterSixDigit: 'Enter 6-Digit Code',
    verify: 'Verify',
    RecoveryCodes: 'Recovery Codes',
    NoCode: ' No recovery codes available.',
    SharedKey: 'Google Auth Shared Key',
    Enable2fa: 'Enable 2FA',
    EnableTwoFactor: 'Enable Two-Factor Authentication',
    note: 'Click the button below to generate your Google Authenticator QR code.',
    Disable2fa: 'Disable 2fa',
  },
  Enable2fa: `2-Factor Authentication`,
  CRUD: {
    Create: `Create`,
    CreateTrade: `Create Trade`,
    WithdraFromAccount: `Withdraw Cash From account`,
    DepositToAccount: `Deposit Cash To account`,
    DepositToUser: `Transfer Cash`,
    CreateLoan: `Create Loan`,
    TakeOrGiveLoan: `Take/Give Loan`,
    PayTakenLoan: `Pay Loan`,
    TradeEntry: `Enter Trades`,
    DepositCash: `Deposit Cash`,
    WithDrawCash: `Withdraw Cash`,
    TakePaidLoan: `Receive Loan`,
    Update: `Update`,
    Delete: `Delete`,
    List: `List`,
    Back: `Back`,
    back: 'Back',
    Save: 'Save',
    DeleteTitle: ` Are you sure to Delete?`,
    Remarks: `Remarks`,
    Reject: 'Reject ',
    Detail: `Detail`,
    Cancle: 'Cancel',
    Remove: 'Remove',
    Reset: 'Reset',
    BackToList: 'Back To List',
    AddAttchment: 'Add New Attachment',
    AddNew: 'Add New',
    Approve: 'Approve',
    Search: 'Search',
    Add: 'Add',
    //
    SelectOption: 'Select Options',
    Yes: 'Yes',
    No: 'No',
    SearchButton: 'Search',
    SearchPlaceholder: 'Search...',
    Close: 'Close',
    // propery
    ChangeStatus: 'Change Status',
    Assign: 'Assign',
    Pay: 'Pay',
    Assignment: 'Assign To',
    Payment: 'Due Payment',
  },

  docs: {
    hi: `Hi`,
    description: `Need help? \n Please check our docs.`,
    documentation: `documentation`,
  },

  MainAsset: {
    AddTitle: `Add Account`,
    UpdateTitle: `Update Account`,
    MainAssetList: `Accounts List`,
    New: `New Account`,
    Update: `Update Accounts`,
    AssetType: `Account Type`,
    Owneruser: `Owner User`,
    DepositDate: `Deposit Date`,
    BalanceAmount: `Account Balance`,
    Description: `Description`,
    MainAsset: `Account`,
  },
  AssetType: {
    AssetTypeList: 'Account Type List',
    Placeholder: 'Search Account Type here...',
    CreateAssetType: 'Create Account Type',
    AssetType: `Edit Account Type`,
    New: 'New Account Type',
    Update: 'Update Account Type',
    Title: 'Account Type',
    AddTitle: 'Add Account Type',
    UpdateTitle: 'Update Account Type',
  },
  Branch: {
    Branch: `Branch`,
    ParentName: `Parent Name`,
    ModifiedOn: `Modified on`,
    BranchList: `Branch List`,
    Placeholder: `Search branch here`,
    Address: `Branch Address`,
    Parent: `Branch Parent`,
    CreateBranch: `Create Branch`,
    EditBranch: `Edit Branch`,
    New: `New Branch`,
    Update: `Update Branch`,
    AddTitle: 'Add Branch',
    UpdateTitle: 'Update Branch',
  },
  PaymentType: {
    PaymentType: `Payment Type`,
    ParentName: `Parent Name`,
    ModifiedOn: `Modified on`,
    PaymentTypeList: `Payment Type List`,
    Placeholder: `Search Payment Type here....`,
    Address: `Payment Type Address`,
    Parent: `Payment Type Parent`,
    CreatePaymentType: `Create Payment Type`,
    EditPaymentType: `Edit Payment Type`,
    New: `New Payment Type`,
    Update: `Update Payment Type`,
    AddTitle: 'Add Payment Type',
    UpdateTitle: 'Update Payment Type',
  },
  Partners: {
    Partners: `Partners`,
    ParentName: `Parent Name`,
    ModifiedOn: `Modified on`,
    PartnersList: `Partners List`,
    Placeholder: `Search Partners here....`,
    Address: `Partners Address`,
    Parent: `Partners Parent`,
    CreatePartners: `Create Partners`,
    EditPartners: `Edit Partners`,
    New: `New Partners`,
    Update: `Update Partners`,
    AddTitle: 'Add Partners',
    UpdateTitle: 'Update Partners',
  },
  CurrencyType: {
    CurrencyType: `Currency Type`,
    ParentName: `Parent Name`,
    ModifiedOn: `Modified on`,
    CurrencyTypeList: `Currency Type List`,
    Placeholder: `Search Currency Type here....`,
    Address: `Currency Type Address`,
    Parent: `Currency Type Parent`,
    CreateCurrencyType: `Create Currency Type`,
    EditCurrencyType: `Edit Currency Type`,
    New: `New Currency Type`,
    Update: `Update Currency Type`,
    AddTitle: 'Add Currency Type',
    UpdateTitle: 'Update Currency Type',
  },
  LoanType: {
    LoanType: `Loan Type`,
    Title: `Loan Type`,
    LoanTypeList: `Loan Type List`,
    Placeholder: `Search Loan Type here`,
    CreateLoanType: 'Create Loan Type',
    EditLoanType: 'Edit Loan Type',
    New: 'New Loan Type',
    Update: 'Update Loan Type',
    AddTitle: 'Add Loan Type',
    UpdateTitle: 'Update Loan Type',
  },

  Categorys: {
    Categorys: `Categorys`,
    Title: `Categorys`,
    CategorysList: `Categorys Type List`,
    Placeholder: `Search Categorys here`,
    CreateCategorys: 'Create Categorys',
    EditCategorys: 'Edit Categorys',
    New: 'New Categorys',
    Update: 'Update Categorys',
    AddTitle: 'Add Categorys',
    UpdateTitle: 'Update Categorys',
  },
  PropertyConditions: {
    PropertyConditions: `Property Conditions`,
    Title: `Property Conditions`,
    PropertyConditionsList: `Property Conditions Type List`,
    Placeholder: `Search Property Conditions here`,
    CreatePropertyConditions: 'Create Property Conditions',
    EditPropertyConditions: 'Edit Property Conditions',
    New: 'New Property Conditions',
    Update: 'Update Property Conditions',
    AddTitle: 'Add Property Conditions',
    UpdateTitle: 'Update Property Conditions',
  },
  Property: {
    AddTitle: 'Property Create',
    PropertyList: 'Property List',
    UpdateTitle: 'Update Property',
    DetailsTitle: 'Property Details',
    New: 'New Property',
    Update: 'Update Property',
    Employee: 'Employee Name',
    PropertyConditions: `Property Conditions`,
    Model: `Model`,
    PaymentDate: `Payment Date`,
    Payments: `Payments`,
    Payment: `Payment`,
    Price: `Price`,
    Assignments: `Assignments`,
    Assignment: `Assignment`,
    AmountPaid: `Amount Paid`,
    PayableAmount: `Payable Amount Paid`,
    RemainingBalance: `Remaining Balance`,
    MaintenanceHistory: `Maintenance History`,
    Placeholder: `Search here ....`,
  },

  Partner: {
    Partner: `Partner `,
    PartnerPhone: `Partner Phone `,
  },
  Department: {
    Dashboard: 'Dashboard',
  },
  TradeTracking: {
    TradeTracking: 'Trade History List',
    Title: 'Trade History',
    New: 'New Trade',
    Update: 'Update Trade',
    EnterTrade: 'Enter Trades',
    TradeAmount: 'Trade Amount',
    ProfitAmount: 'Profit Amount',
    LossAmount: 'Loss Amount',
    CreateTradeTracking: 'Create Trade',
    Placeholder: 'Search Trades',
  },
  ExpenseTracking: {
    ExpenseTracking: 'Expense History List',
    Title: 'Expense History',
    New: 'New Expense',
    Create: 'Create Expense',
    Edit: 'Update Expense',
    Update: 'Update Expense',
    EnterExpense: 'Enter Expenses',
    ExpenseAmount: 'Expense Amount',
    ProfitAmount: 'Profit Amount',
    LossAmount: 'Loss Amount',
    CreateExpenseTracking: 'Create Expense',
    Placeholder: 'Search Expenses',
  },
  WithdrawalTracking: {
    WithdrawalTracking: 'Withdrawal History List',
    Title: 'Withdrawal History',
    New: 'New Withdrawal',
    Create: 'Create Withdrawal',
    Edit: 'Update Withdrawal',
    CreateDeposit: 'Create Deposit',
    EditDeposit: 'Update Deposit',
    DepositToAccount: 'Deposit To Account',
    Update: 'Update Withdrawal',
    EnterWithdrawal: 'Enter Withdrawals',
    WithdrawalAmount: 'Withdrawal Amount',
    ProfitAmount: 'Profit Amount',
    LossAmount: 'Loss Amount',
    CreateWithdrawalTracking: 'Create Withdrawal',
    Placeholder: 'Search Withdrawals',
  },
  ExpenseType: {
    ExpenseType: `Expense Type`,
    ExpenseTypeList: `Expense Type List`,
    Placeholder: `Search Expense Type Here...`,
    CreateExpenseType: 'Create Expense Type',
    EditExpenseType: `Edit Expense Type`,
    New: `New Expense Type`,
    Update: `Update Expense Type`,
  },
  npxChartDashboard: {
    TotalUsers: `Total Users`,
    TotalBracnhes: `Total Branches`,
  },
  //========================== Menu Translation ========================
  AssetManagementMenu: `Account Management`,
  LoanTrackingMenu: `Loan Management`,
  TradeTrackingMenu: `Trade Management`,
  ExpenseTrackingMenu: `Expense Management`,
  WithdrawalTrackingMenu: `Withdraw Management`,
  lookuptable: `System Settings`,
  BranchMenu: `Branch`,
  ExpenseTypeMenu: `Expense Type`,
  AssetTypeMenu: `Account Type`,
  LoanTypeMenu: `Loan Type`,
  PaymentTypeMenu: `Payment Type`,
  CurrencyTypeMenu: `Currency Type`,
  PartnersMenu: `Partners`,
  // ========================= End Menu Translation =====================

  LoanTracking: {
    AddTitle: `Create Loan`,
    UpdateTitle: `Update Loan`,
    CreateLoanTracking: `Create New Loan`,
    EditLoanTracking: `Edit Loan`,
    LoanTrackingList: `Loans List`,
    New: `New Loan`,
    Update: `Update Loan`,
    LoanAmount: `Loan Amount`,
    PaidAmount: `Paid Amount`,
    RemainAmount: `Remain Amount`,
    Placeholder: `Search Loan Records`,
    GiveLoan: `Give Loan`,
    TakeLoan: `Take Loan`,
  },

  //Login Page
  login: {
    SignInToMinistry: 'Sign In to Choqorak Management System',
    WelcomeBack: 'Hi, Welcome Back',
    UserName: 'User Name',
    Password: 'Password',
    RememberMe: 'Remember Me',
    Login: 'Login',
    ForgotPassword: 'Forgot Password?',
    SendEmail:
      'Please enter the email address associated with your account and We will email you a link to reset your password.',
    EmailMustBe: 'Email must be a valid email address',
    EmailIsRequired: 'Email is required',
    EmailAddress: 'Email Address',
    SendRequest: 'Send Request',
    RequestSent: 'Request sent successfully!',
    WeHaveSent: 'We have sent a 4-digit confirmation email to your email.',
    PleaseEnter: 'Please enter the code in below box to verify your email.',
    VerifyCode: 'Verify Code',
    DontHaveACode: `Don't have a code?`,
    ResendCode: 'Resend code',
    ConfirmNewPassword: 'Confirm New Password',
    ChangePassword: 'Change Password',
    PasswordMustBe: 'Password must be at least 6 characters',
    PasswordIsRequired: 'Password is required',
    ConfirmPassword: 'Confirm password is required',
    PasswordMatch: 'Passwords must match',
    EmailNotExist: 'Email does not exist, please register your account!',
    InvalidCode: 'Invalid code, please try again!',
  },

  Pagination: {
    RowsPerPage: 'Rows Per Page',
    Dense: 'Dense',
    Of: 'of',
  },
  Validation: {
    EnglishName: 'English Name is Required',
    DariName: 'Dari Name is Required',
    PashtoName: 'Pashto Name is Required',
    EnglishSurName: 'English Sur Name is Required',
    PashtoSurName: 'Pashto Sur Name is Required',
    Code: 'Code is Required',
    Remark: 'Please Enter Remarks',
    Address: 'Address is Required.',
    Name: 'Name is Required.',
    ContactNumber1: 'Contact Number 1 is Required',
    ContactNumber2: 'Contact Number 2 is Required',
    Email: 'Email is Required.',
    Detail: 'Detail is Required',
    User: 'User is required.',
    Comments: 'Comments is required.',
    Description: 'Description is required',
    FatherEnglishNameIsRequired: 'Father English Name is required',
    FatherDariNameIsRequired: 'Father Pashto Name is required',
    GrandFatherEnglish: 'Grand Father English Name is required',

    GrandFatherPashto: 'Grand Father Pashto Name is required',
    GenderIsRequired: 'Gender is requiree',
    PositionIsRequired: 'Position is required',
    DegreeIsRequired: 'Please select Employee Degree',
    DateOfBirth: 'Date of Birth is Required',
    TemporaryAddress: 'Temporary Address is Required',
    PermanentAddress: 'Permanent Address is Required',
    CNIC: 'CNIC Number is Required',
    Gender: 'Please Select the Gender, it is Required',
    JoinDate: 'Join Date is Required',
    PersonalEmail: 'Personal Email is Required',
    OfficialEmail: 'Official Email is Required',
    Province: 'Please Select the Province, it is Required',
    District: 'Please Select the District, it is Required',
    BloodGroup: 'Please Select the Blood Group, it is Required',
    LeaveDate: 'Leave Date is Required',
    LeaveRemarks: 'Please add Leave Remarks',
    isCurrent: 'Is it Current Employee',
    ProfilePhoto: 'Profile Photo is Required',
    EmployeeHealthStatus: 'Please Select Employee Health Status, it is Required',
    CountryNameIsRequired: 'Please Select Country Name, it is Required',
    //EmailIsRequired: "Email is required",
    //Main Activity
    ProcessStatus: 'Please Select Process Status',
    StartDate: 'Please Select Start Date',
    EndDate: 'Please Select End Date',
    description: 'Description is required',
    //ContractDetailsType
    contractType: 'Please Select Contract Type, it is Required',
    positionTitle: 'Please Select Position Title, it is Required',
    jobPosition: 'Please Select Job Position, it is Required',
    grade: 'Please Select Grade, it is Required',
    gradeStep: 'Please Select Grade Step, it is Required',
    department: 'Please Select Directorate, it is Required',
    //EducationLevelDetails
    educationLevel: 'Please Select Education Level, it is Required',
    educationTitle: 'Please Select Education Title, it is Required',
    englishUniName: 'Educational Authority English Name is Required',
    pashtoUniName: 'Educational Authority Pashto Name is Required',
    dariUniName: 'Educational Authority Dari Name is Required',
    comment: 'Comment is required',
    DoubleClick: 'Double Clickd to Show',
    RequestDoubleClick: 'Double Clickd to Show',
    DocumentDetails: 'Document Details',
    RequestDetails: 'Request Details',
    ClickHere: 'Click here to highlite details',
    //
    FromDate: 'From Date is required',
    ToDate: 'To Date is required',
    //Grade
    ContractType: 'Please select Contract Type, It is required',
    DistrictCode: 'District Code is required',
    EmployeeIsRequired: 'Employee is required',
    TitleIsRequired: 'Title is required',
    // NPFX
    ExpenseType: 'Expense Type is Required',
    Account: 'Account is Required',
    Branch: 'Branch is Required',
    Date: 'Date is Required',
    Amount: 'Amount is Required',
    LoanAmount: 'Loan Amount is Required',
    LoanType: 'Loan Type is Required',
    CurrencyType: 'Currency Type is Required',
    AccountType: 'Account Type is Required',
    OwnerUser: 'Owner User is Required',
    DepositDate: 'Deposit Date is Required',
    BalanceAmount: 'Balance Amount is Required',
    DepositAmmount: 'Deposit Ammount is Required',
    ToUser: 'To User is Required',
    TradeAmount: 'Trade Amount is Required',
    WithdrawalAmount: 'Withdrawal Amount is Required',
    // Property Validation
    PropertyIsRequired: 'Property is Required',
    ConditionId: 'Condition is Required',
    Category: 'Category is Required',
    Price: 'Price is Required',
    AmountPaid: 'AmountPaid is Required',
    PaymentDate: 'Payment Date is Required',
    attachment: 'attachment is Required',
  },

  // Fields names which repeadedly uses in tables
  GeneralFields: {
    Id: 'Id',
    Name: 'Name',
    Status: 'Status',
    NameInEnglish: 'English Name',
    NameInPashto: 'Pashto Name',
    NameInDari: 'Dari Name',
    Code: 'Code',
    Action: 'Action',
    StartDate: 'Start Date',
    EndDate: 'End Date',
    Remarks: 'Remarks',
    Description: 'Description',
    Date: 'Date',
    DueDate: 'Due Date',
    OneDollor: '1 USD =',
    AFN: 'AFN',
    USD: 'USD',
    No: 'No',
    SelectAll: 'Select All',
  },

  Tostar: {
    CreateSuccess: 'Successfuly Created!',
    UpdateSuccess: 'Successfuly Updated',
    RejectSuccess: 'Rejected Successfully!',
    RejectFaild: 'Faild To Reject!',
    UserActivated: 'User Activated!',
    UserDeactivated: 'User Deactivated!',
    DeleteSuccess: 'Deleted Successfully',
    DeleteFailed: 'Delete Failed',
    DataIsAlreadyExist: 'Data is already exist',
    LoginSuccess: 'Login Successfuly!',
    TaskReAsign: 'Task ReAsigned Successfuly',
    ApproveSuccess: 'Successfuly Approved',
    CardAssignedSuccess: 'Card Assigned Successfuly!',
    NewTicket: 'New Ticket',
    TicketCompleted: 'Ticket Completed',
    TicketRejected: 'Ticket Rejected',
    TicketReceived: 'Ticket Received',
    MarkedAsRead: 'Marked as Read',
    MarkedAsUnRead: 'Marked as Unread!',
    ChangePassword: 'Password changed successfuly',
    ReceivedSuccess: 'Document successfuly received',
    ContractNeedApproval: 'Contract Need Approval',
    AdvanceRecieved: 'Advance Payment is Recieved',
  },
  ProcessStatus: {
    Title: 'Process Status: List',
    CreateTitle: 'Process Status: Create New',
    ProcessStatusList: 'Process Status List',
    ProcessStatus: 'Process Status',
    Placeholder: 'Search Process Status',
    NewProcessStatus: 'New Process Status',
    UpdateProcessStatus: 'Update Process Status',
    CreateProcessStatus: 'Create Process Status',
    EngName: 'Eng Name',
    PsName: 'Pashto Name',
    DrName: 'Dari Name',
    DocCode: 'Document Code',
    Action: 'Action',
    Id: '#',
  },

  APPlication: {
    App: 'Application',
    AppList: 'Application List',
    Placeholder: 'Search Application...',
    Id: 'ID',
    Action: 'Action',
    Title: 'Title',
    Abbrevation: 'Abbrivation',
    IconClass: 'Icon Class',
    DefaultRoute: 'Default Route',
    Area: 'Area',
    Description: 'Description',
    NewApp: 'New Application',
    UpdateApp: 'Update Application',
    CreateApp: 'Create Application',
  },

  //Notifications
  Notifications: {
    Notifications: 'Notifications',
    New: 'NEW',
    BeforeThat: 'BEFORE THAT',
    ViewAll: 'View All',
    From: 'From',
    ViewMore: 'View More',
    All: 'All',
    Unread: 'Unread',
  },
  //HR Employee
  Employee: {
    Title: 'Employee: Employee List',
    EmployeeList: 'Employee List',
    Id: 'ID',
    Name: 'Name',
    FatherName: 'Father Name',
    EmployeeType: 'Employee Type',
    Department: 'Directorate',
    Position: 'Position',
    Action: 'Action',
    Email: 'Email',
    PhoneNumber: 'Phone Number',
    Placeholder: 'Search Employee by Name, Directorate or Phone Number...',
    CreateTitle: 'Employee: Create Employee',
    CreateEmployee: 'Create a New Employee',
    UpdateEmployee: 'Update Employee',
    NewEmployee: 'New Employee',
    UpdateEmp: 'Update Employee',
    EnglishName: 'Name in English',
    DariName: 'Local Name ( Position Title)',
    PashtoName: 'Name in Pashto',
    FatherEnglishName: 'Father Name in English',
    FatherDariName: 'Father Name in Pashto',
    Gender: 'Gender',
    Male: 'Male',
    Female: 'Female',
    Official: 'Official',
    Contractual: 'Contractual',
    Intermittently: 'Intermittently',
    JoinDate: 'Join Date',
    EmployeeDegree: 'Employee Degree',
    BloodGroup: 'Blood Group',
    AttendanceId: 'Attendance ID',
    Details: 'Details',
    CreateUser: 'Create Account',
    ContractDetails: 'Job History',
    CardDetails: 'Card Details',
    EducationalLevelDetails: 'Education Level',
    EnglishBioData: 'English Bio Data Information',
    PashtoDariBioData: 'Pashto/Dari Bio Data Information',
    ProfilePhoto: 'Profile Photo',
    CropImage: 'Crop Image',
    TazkiraType: 'Tazkira Type',
    ETazkira: 'E-Tazkira',
    PaperBaseTazkira: 'Paper Base Tazkira',
    JoldNo: 'Jold No',
    PageNo: 'Page No',
    RegNo: 'Reg No',
    isActive: 'isActive',
    //
    englishSurName: 'Sur Name in English ',
    pashtoSurName: 'Sur Name in Pashto ',
    englishGrandFatherName: 'Grand Father Name in English',
    pashtoGrandFatherName: 'Grand Father Name in Pashto',
    dateOfBirth: 'Date of Birth',
    temporaryAddress: 'Temporary Address',
    permanentAddress: 'Permanent Address',
    attendanceId: 'Attendance Id',
    cnic: 'CNIC',
    leaveDate: 'Leave Date',
    leaveRemark: 'Leave Remarks',
    personalEmail: 'Personal Email',
    officialEmail: 'Official Email',
    rfidNumber: 'RFID Number',
    isCurrent: 'Is Current Employee',
    IsCurrentContract: 'Contract Status',
    emergencyPhoneNumber: 'Emergency Phone Number',
    registrationNumber: 'Registration Number',
    Province: 'Province',
    District: 'District',
    Employee: 'Employee',
    DoubleClick: 'Double Click to show ',
    EmployeeDetail: ' Details',
    //EmployeeDetails
    DetailsTitle: 'Employee: Details',
    EmployeeDetails: 'Employee Details',
    EmployeeHealthStatus: 'Employee Health Status',
    EmployeeGeneralInfo: 'Employee General Information',
    //Employee Report
    EmployeeReportTitle: 'Employee: Employee Report',
    EmployeeReport: 'Employees Report',
    HasAccount: 'Has Account',
    hasAccount: 'Yes',
    NoAccount: 'No',
    FullName: 'Full Name',
    Account: 'Account',
  },
  EmployeeProperty: {
    PopertyDetails: 'Property Details',
    EmployeePropertyDetails: 'Employee Property Details',
    Name: 'Name',
    Category: 'Category',
    Model: 'Model',
    Price: 'Price',
    Details: 'Details',
  },

  //ContractDetails
  ContractDetails: {
    Title: 'Contract Details: List',
    ContractDetailsList: 'Contract Details List',
    Placeholder: 'Search Contract Details...',
    AddTitle: 'Contract Details: Create',
    CreateContractDetails: 'Create Contract Details',
    UpdateTitle: 'Contract Details: Update',
    EditContractDetails: 'Edit Contract Details',
    New: 'Creation of Contract Details',
    Update: 'Updating of Contract Details',
    Active: 'Active',
    ContractWarning:
      'Warning: Save Button is disabled because the employee current contract is not ended/expired, Please update employee current contract.',
    BranchName: 'Branch Name',
    SalaryPerHour: 'Salary Per Hour',
    Action: 'Action',
    BackToEmployee: 'Back To Employee',
    Branch: 'Branch',
    currencyType: 'currency Type',
    salaryAmount: 'Salary Amount',
    positionTitle: 'Position Title',
  },
  //Employee Degree
  EmployeeDegree: {
    Title: 'Employee Degree: Employee Degree List',
    EmployeeDegreeList: 'Employee Degree List',
    Placeholder: 'Search Employee Degree...',
    CreateTitle: 'Employee Degree: Create Employee Degree',
    CreateEmployeeDegree: 'Create Employee Degree',
    EditEmployeeDegree: 'Edit Employee Degree',
    NewEmployeeDegree: 'New Employee Degree',
    UpdateEmployeeDegree: 'Update Employee Degree',
  },
  //Employee Position
  EmployeePosition: {
    Title: 'Employee Position: Employee Position List',
    EmployeePositionList: 'Employee Position List',
    Placeholder: 'Search Employee Position...',
    CreateTitle: 'Employee Position: Create Employee Position',
    CreateEmployeePosition: 'Create Employee Position',
    EditEmployeePosition: 'Edit Employee Position',
    NewEmployeePosition: 'New Employee Position',
    UpdateEmployeePosition: 'Update Employee Position',
  },
  //Pending Requests
  PendingRequests: {
    Title: 'Pending Requests',
    List: 'Pending Requests List',
    Placeholder: 'Search Pending Requests by Tracking Number, Request Number or User Name',
    ReAsign: 'ReAsign',
    ReAsignTitle: 'Do you want to ReAsign the task?',
  },

  //News
  News: {
    ListTitle: 'News: News List',
    List: 'News List',
    News: 'News',
    CreateTitle: 'News: Create News',
    CreateNews: 'Create a new News',
    NewsDate: 'News Date',
    Title: 'Title',
    Description: 'Description',
    SelectDepartment: 'Select Departments',
    AddAttachments: 'Add Attachments',
    Placeholder: 'Search News by Title, Description and Speaker...',
    Speaker: 'Speaker',
    Location: 'Location',
    UpdateTitle: 'News: Update News',
    UpdateNews: 'Update News',
    Create: 'Creating News',
    Update: 'Updating News',
    SelectAll: 'Select All',
    ShowNotification: 'Show Notification',
    True: 'Yes',
    False: 'No',
    WriteContentsHere: 'Write your descriptions here...',
    StartTime: 'Start Time',
    EndTime: 'End Time',
    FreshNews: 'Fresh News',
    Download: 'Download',
  },
  //Administrative Forms
  TrainingVideo: {
    Title: 'Training Videos: List',
    List: 'Training Videos List',
    CreateTitle: 'Training Videos: Create',
    CreateTrainingVideo: 'Add a New Training Video',
    //Download: 'Download',
    UpdateTitle: 'Training Videos: Update',
    UpdateTrainingVideo: 'Update Training Video',
    Create: 'Adding of Training Video',
    Update: 'Updating of Training Video',
    //FormInfo: 'Form Information',
    Placeholder: 'Search Training Videos here...',
    Application: 'Application',
    TrainingVideo: 'Training Video',
    VideoPlayer: 'Video Player',
    PlayerTitle: 'Training Videos: Player',
    FilterByApp: 'Filter by Application',
    VideoList: 'Videos List',
    PleaseSelectAVideo: 'Please select a video',
    DariTitle: 'Dari Title',
    PashtoTitle: 'Pashto Title',
    AddDariVideo: 'Add Dari Video',
    AddPashtoVideo: 'Add Pashto Video',
    AddPoster: 'Add Video Poster',
    AddAttachments: 'Adding Attachments',
  },

  //User Management
  User: {
    user: 'User',
    newUser: 'New User',
    userList: 'User List',
    userName: 'User Name',
    fullUserName: 'Full User Name',
    email: 'Email',
    Branch: 'Branch',
    isActive: 'Is Active',
    unActive: 'UnActive',
    Active: 'Active',
    Banned: 'Banned',
    createUser: 'Create a New User',
    editUser: 'Edit User',
    Placeholder: 'Search User ...',
    phoneNumber: 'Phone Number',
    positionTitle: 'Position Title',
    Language: 'Language',
    userRoles: 'User Roles',
    AllowedDepartments: 'Allowed Directorates',
    AllowedSecurityLevels: 'Allowed Security Levels',
    AllowedDocumentType: 'Allowed Document Type',
    Organization: 'Organization',
    CreateUser: 'Create User',
    UpdateChanges: 'Update Changes',
    Allowed: 'Allowed *.jpeg, *.jpg, *.png',
    MaxSize: 'max size of',
    UploadPhoto: 'Upload Photo',
    UpdatePhoto: 'Update Photo',
    NoPositionAdded: 'No Position Added',
    SecurityLevel: 'Security Level',
    UserDetails: 'User Detatils',
    ResetPassword: 'Reset Password',
    NewPassword: 'New Password',
    ChangePassword: 'Change Password',
    CurrentPassword: 'Current Password',
    ConfirmNewPassword: 'Confirm New Password',
    Title: 'User: User List',
    active: 'Active',
    Deactive: 'Deactive',
    AppName: 'App Name',
    Description: 'Description',
    EnglishName: 'Name in English',
    Code: 'Code',
    PashtoName: 'Name in Pashto',
    DariName: 'Name in Dari',
    About: 'About',
    Contact: 'Contact',
    GeneralInfo: 'General Information',
    ProfileTitle: 'User: Profile',
    Profile: 'Profile',
    UserPosition: 'User Position',
    Employee: 'Employee',
    Representator: 'Representator',
    userPassword: 'User Password',
    department: 'Directorate',
    isManager: 'Is Executive Manager',
    Action: 'Action',
    ActionOn: 'Action On',
    IpAddress: 'IP Address',
    Message: 'Message',
    Server: 'Server',
    BrowserName: 'Browser Name',
    Os: 'OS',
    userLogTitle: 'User Log: List',
    userLogList: 'User Log List',
    ActiveUsers: 'Active Users',
    Managers: 'Managers',
    ToggleOrientation: 'ToggleOrientation',
    UserReport: 'Users Report',
    Day: 'Day',
    // Validation
    PleaseEnterNewPassword: 'Please Enter New Password',
    UserNameIsRequired: 'User Name is required',
    EmailIsRequired: 'Email is required',
    NumberFormat: 'Number Format Should be +937xxxxxxxxx',
    PhoneNumberIsRequired: 'Phone Number is required',
    PositionTitleIsRequired: 'Position Title is required',
    LanguageIsRequired: 'Language is required',
    PleaseEnterRmarks: 'Please Enter Remarks',
    CurrentPassIsRequired: 'Current Password is required',
    AtLeastChar: 'Password must be at least 6 charecters',
    NewPassIsRequired: 'New Password is required',
    passMustMatch: 'Passwords must match',
    PasswordIsRequired: 'Password is Required',
    NewPassRequiresAlpha: 'Password must include charecters',
    NewPassRequiresNumber: 'Password must include numbers',
    NewPassRequiresSpecialChar: 'Password must include special charecters',
  },
  //Account
  Account: {
    Home: 'Home',
    Profile: 'Profile',
    Logout: 'Logout',
  },
  //Role
  userRole: {
    Id: 'ID',
    Application: 'Application',
    Name: 'Name',
    Description: 'Description',
    Permission: 'Permission',
    TotalPermissions: 'Total Permissions',
    PermissionName: 'Permission Name',
    ControllerName: 'Controller Name',
    Method: 'Method',
    RoleList: 'Role List',
    Role: 'Role',
    Placeholder: 'Search Role ...',
    CreateNewRole: 'Create a New Role',
    EditRole: 'Edit Role',
    NewRole: 'New Role',
    RoleEdit: 'Edit Role',
    CreateRole: 'Create Role',
    UpdateRole: 'Update Role',
    RoleDetails: 'Details of Role',
    RoleName: 'Role Name',
    PermissionDetails: 'Permission Details',

    //Validation
    NameIsRequired: 'Name is required',
    AppIsRequired: 'Application is required',
    DescriptionIsRequired: 'Description is required',
  },
  //permission
  userPermission: {
    ApplicationName: 'Application Name',
    isActionCategoryMissing: 'isActionCategoryMissing',
    Controller: 'Controller',
    ActionCategory: 'Action Category',
    SaveAll: 'Save All',
    IsGlobal: 'isGlobal',
    Id: 'ID',
    Name: 'Name',
    PermissionController: 'Controller',
    Action: 'Action',
    Method: 'Method',
    Application: 'Application',
    PermissionList: 'Permission List',
    Placeholder: 'Search Permission ...',
  },

  //UMS
  UMS: 'UMS',
  UserManagement: 'User Management',
  Permission: 'Permission',
  Role: 'Role',
  createUser: 'Create User',
  Userlist: 'User List',
  UserLogList: 'User Log List',
  changePassword: 'Change Password',

  HRDashboard: {
    HRDashboard: 'HR Dashboard',
    TotalEmployeesHasUser: 'Total Employees who have User accounts',
    TotalActiveEmployeeByDepartments: 'Total Active Employees by Departments',
  },

  Dashboard: {
    MISWorkDashboard: 'MIS Work Dashboard',
    ReceptionDashboard: 'Reception Dashboard',
    ArchiveDashboard: 'Archive Dashboard',
    InternalDocumentDashboard: 'Internal Document Dashboard',
    ExternalDocumentDashboard: 'External Document Dashboard',
    UserPerformanceDashboard: 'User Performance Dashboard',
    ITSMSDashboard: 'IT-SMS Dashboard',
    UserSummaryDashboard: 'User Summary Dashboard',
  },
  Npfx: {
    NpfxWellcome: 'WELCOME TO CHOQORAK MARKET MANAGEMENT SYSTEM',
    NPFXMarket: 'CHOQORAK Market',
    TodayTotalExpense: 'Today Total Expense',
    CurrentBalance: 'Current Balance',
    TodayTotalLoss: 'Today Total Loss',
    TodayTotalProfit: 'Today Total Profit',
    TodayTotalTrade: 'Today Total Trade',
    TradeChart: 'Trade Chart',
    Profit: 'Profit',
    Loss: 'Loss',
    Day: 'Day',
    Week: 'Week',
    Month: 'Month',
    Year: 'Year',
    Period: 'Period',
    DataPoints: 'Data Points',
    Categories: 'Categories',
    TotalAmount: 'Total Amount',
    ExpensesByCategories: 'Expenses By Categories',
    MemberBalance: 'Member Balance',
  },
  ProcessName: {
    All: 'All',
    Completed: 'Completed',
    InProcess: 'In Process',
    Pending: 'Pending',
    NotCompleted: 'Not Completed',
    Approve: 'Approve',
    Reject: 'Reject',
    DocumentProcessEnd: 'Document Process End',
    ReplytoReceivedDocument: 'Reply to Received Document',
    ExecuteandMessageSending: 'Execute and Message Sending',
    ProcessStart: 'Process Start',
    Sent: 'Sent',
    Received: 'Received',
    DueGiven: 'Due Given',
    DueTaken: 'Due Taken',
  },

  //Education Title
  EducationTitle: {
    Title: 'Education Title: List',
    AddTitle: 'Education Title: Create',
    UpdateTitle: 'Education Title: Update',
    educationTitleList: 'Education Title List',
    educationTitle: 'Education Title',
    dashboard: 'Dashboard',
    iD: 'ID',
    engName: 'Name in English',
    dariName: 'Name in Dari',
    pashtoName: 'Name in Pashto',
    code: 'Code',
    action: 'Action',
    remarks: 'Please Enter Remarks',
    searchPlaceHolder: 'Search Education Title by English Name, Pashto Name, Dari Name or Code...',
    updateEducationTitle: 'Update Education Title',
    newEducationTitle: 'New Education Title',
    New: 'Creation of Education Title',
    Update: 'Updating Education Title',
  },
  EducationLevel: {
    Title: 'Education Level: List',
    AddTitle: 'Education Level: Create',
    UpdateTitle: 'Education Level: Update',
    educationLevelList: 'Education Level List',
    educationLevel: 'Education Level',
    dashboard: 'Dashboard',
    iD: 'ID',
    engName: 'Name in English',
    dariName: 'Name in Dari',
    pashtoName: 'Name in Pashto',
    code: 'Code',
    action: 'Action',
    remarks: 'Please add remarks',
    searchPlaceHolder: 'Search Education Level by English Name, Pashto Name, Dari Name or Code',
    updateEducationLevel: 'Update Educarion Level',
    newEducationLevel: 'New Education Level',
    New: 'Creation of Education Level',
    Update: 'Updating Education Level',
    Country: 'Country',
  },

  //EducationLevelDetails
  EducationLevelDetails: {
    Title: 'Education Level Details: List',
    CreateTitle: 'Education Level Details: Create',
    UpdateTitle: 'Education Level Details: Update',
    EducationLevelDetailsList: 'Education Level Details List',
    Create: 'Create New Education Level Details',
    Edit: 'Edit Education Level Details',
    EmployeeName: 'Employee Name',
    UniversityName: 'Educational Authority',
    New: 'Creation of Education Level Details',
    Update: 'Updating of Education Level Details',
    Placeholder: 'Search Education Level Details...',
    EnglishUniName: 'Educational Authority Name in English',
    PashtoUniName: 'Educational Authority Name in Pashto',
    DariUniName: 'Educational Authority Name in Dari',
  },

  //Province
  Province: {
    Title: 'Main Region: Province List',
    ProvinceList: 'Province List',
    Province: 'Province',
    Id: 'ID',
    Name: 'Province Name',
    Code: 'Code',
    Placeholder: 'Search Provinces',
    AddTitle: 'Province: Create new Province',
    CreateNewProvince: 'Create a New Province',
    UpdateProvince: 'Edit Province',
    NewProvince: 'New Province',
    EditProvince: 'Edit Province',
    EnglishName: 'Name in Englis',
    PashtoName: 'Name in Pashto',
    DariName: 'Name in Dari',
    ProvinceName: 'Province Name',
  },

  //District
  District: {
    Title: 'District: District List',
    DistrictList: 'District List',
    District: 'District',
    Code: 'District Code',
    Placeholder: 'Search districts ...',
    AddTitle: 'District: Create New District',
    CreateNewDistrict: 'Create a New District',
    UpdateDistrict: 'Update District',
    EnglishName: 'Name in English',
    PashtoName: 'Name in Pashto',
    DariName: 'Name in Dari',
    UpdateTitle: 'District: Update District',
  },
  //ContractType
  ContractType: {
    Title: 'Contract Type: List',
    ContractTypeList: 'Contract Type List',
    Placeholder: 'Search Contract Type by English Name, Pashto Name, Dari Name or Code...',
    AddTitle: 'Contract Type: Create',
    CreateContractType: 'Create a New Contract Type',
    UpdateTitle: 'Contract Type: Update',
    EditContractType: 'Edit Contract Type',
    New: 'Creation of Contract Type',
    Update: 'Updating Contract Type',
    ContractType: 'Contract Type',
    ContractStatus: 'Status',
    Current: 'Current',
    Ended: 'Ended',
    EmployeeIsPermanent: 'Employee Is Permanent',
  },

  //Grade
  Grade: {
    Title: 'Grade: Grade List',
    GradeList: 'Grade List',
    Placeholder: 'Search Grades by English Name, Pashto Name, Dari Name or Code...',
    AddTitle: 'Grade: Create Grade',
    CreateGrade: 'Create a New Grade',
    UpdateTitle: 'Grade: Update Grade',
    EditGrade: 'Edit Grade',
    New: 'Creation of Grade',
    Update: 'Updating of Grade',
    Grade: 'Grade',
  },

  //GradeStep
  GradeStep: {
    Title: 'Grade Step: Grade Step List',
    GradeStepList: 'Grade Step List',
    Placeholder: 'Search Grade Step by English Name, Pashto Name, Dari Name or Code...',
    AddTitle: 'Grade Step: Create Grade Step',
    CreateGradeStep: 'Create a New Grade Step',
    UpdateTitle: 'Grade Step: Update Grade Step',
    EditGradeStep: 'Edit Grade Step',
    New: 'Creation of Grade Step',
    Update: 'Updating of Grade Step',
    GradeStep: 'Grad Step',
  },

  //PositionTitle
  PositionTitle: {
    Title: 'Position Title: Position Title List',
    PositionTitleList: 'Position Title List',
    Placeholder: 'Search Position Title by English Name, Pashto Name, Dari Name or Code...',
    AddTitle: 'Position Title: Create Position Title',
    CreatePositionTitle: 'Create a New Position Title',
    UpdateTitle: 'Position Title: Update Position Title',
    EditPositionTitle: 'Edit Position Title',
    New: 'Creation of Position Title',
    Update: 'Updating of Position Title',
    PositionTitle: 'Position Title',
  },

  //JobPosition
  JobPosition: {
    Title: 'Job Position: Job Position List',
    JobPositionList: 'Job Position List',
    Placeholder: 'Search Job Position by English Name, Pashto Name, Dari Name or Code...',
    AddTitle: 'Job Position: Create Job Position',
    CreateJobPosition: 'Create a New Job Position',
    UpdateTitle: 'Job Position: Update Job Position',
    EditJobPosition: 'Edit Job Position',
    New: 'Creation of Job Position',
    Update: 'Updating of Job Position',
    JobPosition: 'Job Position',
    department: 'Directorate',
  },

  processStatus: 'Process Status',
  application: 'Application',
  representator: 'Representator',
  list: 'List',
  create: 'Create',
  year: 'Year',
  ums: 'User management system',
  group: 'Group',
  hr: 'HR',
  emp: 'Employee',
  employeeDegree: 'Employee Degree',
  employeePosition: 'Employee Position',
  province: 'Provice',
  district: 'District',
  //HR
  HRLookupTables: 'HR System',
  contractType: 'Contract Type',

  educationTitle: 'Education Title',
  educationLevel: 'Education Level',

  grade: 'Grade',
  gradeStep: 'Grade Step',
  positionTitle: 'Position Title',
  jobPosition: 'Job Position',
  employeeHealthStatus: ' Health Status',
  cardPrint: 'Card Print',
  //CommonLookUps
  CommonLookUps: 'Common',
  //News
  news: 'News',
  newsList: 'News List',
  addNews: 'Add News',
  //Training Videos
  trainingVideo: 'Training Videos',
  addTrainingVideo: 'Add Video',
  trainingVideolist: 'Videos List',
  trainingVideoPlayer: 'Videos Player',
  //Book Diary
  bookDiary: 'Book Diary',
  contact: 'Contact',
  UserReport: 'Users Report',
  EmployeeReport: 'Employees Report',

  Report: {
    FromDate: 'From Date',
    ToDate: 'To Date',
    StartDate: 'Start Date',
    EndDate: 'End Date',
    Dashboard: 'Dashboard',
    ExpenseReport: 'Expense Report',
    ExpenseTransaction: 'Expense Transaction',
    LoanReport: 'Loan Report',
    LoanTransaction: 'Loan Transaction',
    TradeReport: 'Trade Report',
    TradeTransaction: 'Trade Transaction',
    Filter: 'Filter',
    Print: 'Print',
    Reset: 'Reset',
    GrandTotal: 'Grand Total',
    No: 'No',
    Branch: 'Branch',
    LoanType: 'Loan Type',
    CurrencyType: 'Currency Type',
    Amount: 'Amount',
    Paid: 'Paid',
    Remain: 'Remain',
    Taken: 'Taken',
    Given: 'Given',
    MainAssetCode: 'Main Asset Code',
    UserName: 'User Name',
    Date: 'Date',
    Description: 'Description',
    ExpenseType: 'Expense Type',
    Dollor: 'Dollor',
    Afghani: 'Afghani',
    ProfitAmount: 'Profit Amount',
    LossAmount: 'Loss Amount',
    debitAmount: 'Debit Amount',
    creditAmount: 'Credit Amount',
    balanceAmount: 'Balance Amount',
    transactionDate: 'Transaction Date',

    Partner: 'Partner',
    partnerPhone: 'Partner Phone',
    loanAmount: 'loan Amount',
    paidAmount: 'paid Amount',
    remainAmount: 'remain Amount',
    expenseType: 'expense Type',
    tradeAmount: 'trade Amount',
    profitAmount: 'profit Amount',
    lossAmount: 'loss Amount',
    FinancialDetails: 'Financial Details'
  },

  //#region Choqorak Market
  //#region Dashboard
  Dashboards: {
    ChoqorakMarketWellcome: 'WELCOME TO CHOQORAK MARKET MANAGEMENT SYSTEM',
    ChoqorakMarket: 'CHOQORAK Market',
    TotalShop: 'TotalShop',
    TotalCustomer: 'Total Customer',
    ActiveContract: 'Active Contract',
    CurrentMonthExpiredContract: 'Current Month Expired Contract',
    ShopBasedOnStatus: 'Shop Based On Status',
    ContractCategorized: 'Contract Categorized',
    CustomerCategorized: 'Customer Categorized',
    ContractFullCustomer: 'Contract Full Customer',
    ContractLessCustomer: 'Contract Less Customer',
    IncomeChart: 'Income Chart',
  },
  //#endregion
  //#region contractInfo

  contractsInfo: {
    No: 'No',
    Title: 'ContractInfo',
    Placeholder: 'Search Contracts',
    CreateTitle: 'Create New Contract Info',
    UpdateTitle: 'Update New Contract Info',
    ContractInfoList: 'Contract Info List',
    Approved: 'Contract Info Approved List',
    UnApproved: 'Contract Info UnApproved List',
    Terminate: 'Contract Info Terminate List',
    AboutToExpire: 'Contract Info List',
    ActiveContractList: 'Active Contract List',
    AboutToExpired: 'Contract Info About To Expire List',
    Expired: 'Contract Info Expired List',
    ContractInfo: 'Contract Info',
    ContractNumber: 'Contract Number',
    CustomerName: 'Customer',
    Contractor: 'Contractor',
    ContractDuration: 'Contract Duration',

    ShopCode: 'ShopCode',
    Approveds: 'Approved',

    NotApproved: 'NotApproved',
    InitialRentAmount: 'Initial Rent Amount',
    FinalRentPerMonth: 'Final Rent PerMonth',
    AdvancePayment: 'Advance Payment',
    RentInfo: 'Rent Info',
    AdvanceRecievedByUserName: 'AdvanceRecievedBy',
    DurationOfDiscount: 'Duration Of Discount',
    TotalContractDurationRent: 'Total Rent',
    TotalContractDurationPaidRent: 'Total  Paid Rent',
    DiscountStartDate: 'Discount StartDate',
    DiscountEndDate: 'Discount EndDate',
    StartDate: ' Start Date',
    EndDate: ' End Date',
    Status: 'Status',
    ExpiredList: 'Expired',
    All: 'All',
    Locked: 'Locked',
    NeedApproval: 'Need Approval',
    ApprovedList: 'Approved',
    ApprovedBy: 'Approved By',
    RecievedAdvanceApproval: 'Advance Pay Approval',
    ContractAttachment: 'Contract Attachment',
    ContractExtend: 'Extend Contract',
    ApprovedAndLock: 'Approved And Lock',
    AddAttachment: 'Add Attachment',
    Attachments: 'Attachments',
    ContractTerminate: 'Terminate',
    ApproveDiscount: 'Approve Discount',
    contractId: 'Contract ID',
    contractNumber: 'Contract Number',
    customerName: 'Customer Name',
    shopCode: 'Shop Code',
    Terminated: 'Terminated',
    IsApproved: 'IsApproved',
    dicountDoc: 'Discount Document',

    NotTerminated: 'Not Terminated',
    contractStartDate: 'Contract Start Date',
    contractEndDate: 'Contract End Date',
    finalRentPerMonth: 'Final Rent Per Month',
    contractStatus: 'Contract Status',
    contractDetails: 'Contract Details',
    Extend: 'Extend',
    documentView: 'Document View',
    RentAdvancePayment: 'Rent  Advance Payment',
    ContractElectricMeterStartDigree: 'Contract Electric Meter Start Digree',
    MarkContractasComplete: 'Mark Contract as Complete',
    LastContractInfo: 'Last Contract Info',
    NewContractInfo: 'New Contract Info',
    SetContractDuration: 'Set Contract Duration by Year',
    HasDiscount: 'HasDiscount',
    ContractCreator: 'Contract Creator',
    TotalRecord: 'Total Record',
    RemainTime: 'RemainTime'
  },
  //#endregion

  //#region Terminated
  Terminate: {
    Title: 'Contract Terminate',
    TerminatedInfo: 'Terminated Info',
    TerminationDate: 'Termination Date',
    SettlmentDeductionAmount: 'Settlment Deduction Amount',
    DeductedAmountFromAdvancePayment: 'deducted Amount From Advance Payment',
    ManuallyPaidAmount: 'Manually Paid Amount',
    RemainAmount: 'Remain Amount',
    DeductionDescription: 'Deduction Description',
    TerminationDescription: 'Termination Description',
    InitialRentAmount: 'Initial Rent Amount',
    RefundedAdvancePayment: 'Refunded Advance Payment',
  },
  //#endregion

  //#region ExpirationSettlement
  ExpirationSettlement: {
    Title: 'Contract Expiration Settlement',
    ExpirationSettlement: 'Exp Settlement',
    ExpirationSettlementInfo: 'Expiration Settlement Info',
    ExpirationSettlementDate: 'Expiration Settlement Date',
    SettlmentDeductionAmount: 'Settlment Deduction Amount',
    DeductedAmountFromAdvancePayment: 'deducted Amount From Advance Payment',
    ManuallyPaidAmount: 'Manually Paid Amount',
    RemainAmount: 'Remain Amount',
    DeductionDescription: 'Deduction Description',
    TerminationDescription: 'Termination Description',
    InitialRentAmount: 'Initial Rent Amount',
    RefundedAdvancePayment: 'Refunded Advance Payment',
  },
  //#endregion

  ContractInfoReport: {
    Title: 'Contract Report',
    ShopReportList: 'Contract Report List',
  },

  //#region rentPayment
  RentPayment: {
    No: 'No',
    Title: 'Rent Payment',
    ContractNumber: 'Contract Number',
    CustomerName: 'Customer Name',
    ShopCode: 'Shop Code',
    Year: 'Year',
    Month: 'Month',
    Paid: 'Paid',
    UnPaid: 'UnPaid',
    Day: 'Day',
    PaymentAmount: 'Payment Amount',
    PaidAmount: 'Paid Amount',
    RemainAmount: 'Remaining Amount',
    PaymentDate: 'Payment Date',
    Description: 'Description',
    RecievedByUserName: 'Received By User Name',
    RentPaymentId: 'Rent Payment ID',
    ContractId: 'Contract ID',
    CustomerId: 'Customer ID',
    CurrencyId: 'Currency ID',
    ShopId: 'Shop ID',
    RecievedByUserId: 'Received By User ID',
    Payment: 'Payment',
    SearchBy: 'SearchBy',
    FromDate: 'From Date',
    Rentof: 'Rent of',
    Generat: 'Generat Rent Payment List',
    RentPaymentReport: 'Rent Payment Report',
    RemainFromThePast: 'Remain From The Past',
    Recieve: 'Recieve',
    CurrentMonthRent: 'Current Month Rent',
    TodaysRecievedAmount: 'Todays Recieved Amount',
    DailyReport: 'Daily Report',
    PaymentMehtod: 'Payment Method',
    CASH: 'CASH',
    FREE: 'FREE',
    TAKEN_FROM_ADVANCE: 'TAKEN FROM ADVANCE',
  },

  RentPaymentPrint: {
    No: 'No',
    Year: 'Year',
    Month: 'Month',
    ContractNumber: 'Contract Number',
    CustomerName: 'Customer Name',
    CustomerPhone: 'Customer Phone',
    ShopCode: 'Shop Code',
    PaymentAmount: 'Payment Amount',
    PaidAmount: 'Paid Amount',
    RemainAmount: 'Remaining Amount',
    Title: 'Report: Payment Details',
    Placeholder: 'Search Reports',
    AddTitle: 'Report: Create New Payment Report',
    CreateNewReport: 'Create a New Payment Report',
    UpdateReport: 'Edit Payment Report',
    NewReport: 'New Payment Report',
    EditReport: 'Edit Payment Report',
    SerialNumber: 'Serial Number',
  },

  //#endregion

  ReportSummary: {
    TotalPaymentAmount: 'Total Payment Amount',
    TotalPaidAmount: 'Total Paid Amount',
    TotalRemainAmount: 'Total Remain Amount',
    TotalPaymentRecords: ' Total Payment Records',
    RecievedByUserName: ' RecievedByUserName',
  },

  // #region ElectricPaymentReport

  ElectricityPrint: {
    No: 'No',
    Year: 'Year',
    Month: 'Month',
    ContractNumber: 'Contract Number',
    CustomerName: 'Customer Name',
    CustomerPhone: 'Customer Phone',
    ShopCode: 'Shop Code',
    PaymentAmount: 'Payment Amount',
    PaidAmount: 'Paid Amount',
    RemainAmount: 'Remaining Amount',
    Title: 'Report: Payment Details',
    Placeholder: 'Search Reports',
    AddTitle: 'Report: Create New Payment Report',
    CreateNewReport: 'Create a New Payment Report',
    UpdateReport: 'Edit Payment Report',
    NewReport: 'New Payment Report',
    EditReport: 'Edit Payment Report',
  },

  ElectricityPayment: {
    Title: 'Electricity Payment',
    ElectricityPaymentList: 'Electricity Payment List',
    ElectricityPaymentReport: 'Electricity Payment Report',
    Filter: 'Filter',
    Dashboard: 'Dashboard',
    FromDate: 'From Date',
    ToDate: 'To Date',
    Block: 'Block',
    Floor: 'Floor',
    Shop: 'Shop',
    No: 'No',
    Year: 'Year',
    Month: 'Month',
    CustomerName: 'Customer Name',
    ShopCode: 'Shop Code',
    RecievedByUserName: 'Received By User',
    PaymentAmount: 'Payment Amount',
    PaidAmount: 'Paid Amount',
    RemainAmount: 'Remaining Amount',
    PaymentDate: 'Payment Date',
    Payment: 'Payment',
    PreviousElectricMeterDegree: 'Previous Degree',
    CurrentElectricMeterDegree: 'Current Degree',
    TotalUsedKilowats: 'Total Used Kilowats',
    PricePerKilowat: 'Price PerKilowat',
    RemaintsOfThePast: 'Remaints Of The Past',
    TotalPayment: 'Total Payment',
    SerialNumber: 'SerialNumber',
    CurrentAmount: 'CurrentAmount',
    Paid: 'Paid',
    UpdateDegree: 'Update Degree',
    Delete: 'Electricitypayment Delete',
  },

  //#endregion

  //#endregion

  //#region block
  Block: {
    Title: 'Block: List',
    CreateTitle: 'Block: Create New',
    BlockList: 'Block List',
    Block: 'Block',
    Placeholder: 'Search Block',
    NewBlock: 'New Block',
    UpdateBlock: 'Update Block',
    CreateBlock: 'Create Block',
    BlockName: 'Block Name',
    BlockAddress: 'Block Address',
    Floor: 'Floor',
    BlockInfo: 'Block Info',
    BlockDetails: 'Block Details',
    NoData: 'No Data',
    Action: 'Action',
    Id: '#',
  },
  //#endregion

  //#region Floor
  Floor: {
    Title: 'Floor: List',
    CreateTitle: 'Floor: Create New',
    FloorList: 'Floor List',
    Floor: 'Floor',
    Placeholder: 'Search Floor',
    NewFloor: 'New Floor',
    UpdateFloor: 'Update Floor',
    CreateFloor: 'Create Floor',
    FloorCode: 'FloorCode',
    Attachfile: 'attach file',
    NofileChosen: 'No file Chosen',
    FloorInfo: 'Floor Info',
    FloorDetails: 'Floor Details',
    NoData: 'No Data',

    Action: 'Action',
    Id: '#',
  },

  //#region ElectricBox
  ElectricBox: {
    Title: 'ElectricBox: List',
    CreateTitle: 'ElectricBox: Create New',
    ElectricBoxList: 'ElectricBox List',
    ElectricBox: 'ElectricBox',
    Placeholder: 'Search ElectricBox',
    NewElectricBox: 'New ElectricBox',
    UpdateElectricBox: 'Update ElectricBox',
    CreateElectricBox: 'Create ElectricBox',
    ElectricBoxCode: 'Electric Box Code',
    Description: 'Description',
    ElectricBoxInfo: 'ElectricBox Info',
    ElectricBoxDetails: 'ElectricBox Details',
    NoData: 'No Data',

    Action: 'Action',
    Id: '#',
  },
  //#endregion
  //#region ElectricMeter
  ElectricMeter: {
    Title: 'ElectricMeter: List',
    CreateTitle: 'ElectricMeter: Create New',
    ElectricMeterList: 'ElectricMeter List',
    ElectricMeterDetails: 'ElectricMeter Details',
    ElectricMeter: 'ElectricMeter',
    Placeholder: 'Search ElectricMeter',
    NewElectricMeter: 'New ElectricMeter',
    UpdateElectricMeter: 'Update ElectricMeter',
    CreateElectricMeter: 'Create ElectricMeter',
    ElectricMeterCode: 'Electric Box Code',
    ElectricMeterSerial: 'Meter Serial',
    ElectricBoxCode: 'ElectricBoxCode',
    ElectricityPrice: 'Price Per Kilowate',
    ElectricConsumption: 'Electric Consumption',
    Consumption: 'Consumption',
    Usage: 'Usage',
    StartDate: 'StartDate',
    EndDate: 'EndDate',
    LastElectricMeterDegree: 'Last Degree',
    CurrentDegree: 'Current Degree',
    ElectricBoxDetails: 'ElectricBox Details',
    Action: 'Action',
    Id: '#',
    ConsumptionList: 'Consumption List',
    UsagePrice: 'Usage Price',
    Checked: 'Checked',
    UnChecked: 'UnChecked',
    ElectricConsumptionUpdate: 'Electric Consumption Update',
  },
  //#endregion

  //#region ShopType
  ShopType: {
    Title: 'ShopType: List',
    CreateTitle: 'ShopType: Create New',
    ShopTypeList: 'ShopType List',
    ShopType: 'ShopType',
    Placeholder: 'Search ShopType',
    NewShopType: 'New ShopType',
    UpdateShopType: 'Update ShopType',
    CreateShopType: 'Create ShopType',
  },
  //#endregion

  //#region ShopType
  ShopContractType: {
    Title: 'Shop Contract Type: List',
    CreateTitle: 'Shop Contract Type: Create New',
    ShopContractTypeList: 'Shop Contract Type List',
    ShopContractType: 'Shop ContractType',
    Placeholder: 'Search Shop Contract Type',
    NewShopContractType: 'New Shop Contract Type',
    UpdateShopContractType: 'Update Shop Contract Type',
    CreateShopContractType: 'Create Shop Contract Type',
  },
  //#endregion

  //#region Status
  Status: {
    Title: 'Status: List',
    CreateTitle: 'Status: Create New',
    StatusList: 'Status List',
    Status: 'Status',
    Placeholder: 'Search Status',
    NewStatus: 'New Status',
    UpdateStatus: 'Update Status',
    CreateStatus: 'Create Status',
    StatusType: 'Status Type',
  },
  //#endregion

  //#region Shop
  Shop: {
    Title: 'Shop: List',
    CreateTitle: 'Shop: Create New',
    ShopList: 'Shop List',
    Shop: 'Shop',
    Placeholder: 'Search Shop',
    NewShop: 'New Shop',
    UpdateShop: 'Update Shop',
    CreateShop: 'Create Shop',

    Floor: 'Floor',
    ShopCode: 'Shop Code',
    Block: 'Block',
    ShopArea: 'ShopArea',
    ElectricBox: 'Electric Box',
    ElectricMeter: 'Electric Meter',
    ShopStatus: 'Shop Status',
    ShopType: 'Shop Type',
    ShopWidth: 'Shop Width',
    ShopLength: 'Shop Length',
    RentPerMonth: 'Rent Per Month',
    RentCurrency: 'Rent Currency',
    ElectricMeterSerial: 'Electric Meter Serial',
    ShopTypeName: 'Shop Type Name',
    BlockName: 'Block Name',
    ShopStatusName: 'Shop Status',
    ShopTypeNameAlt: 'Shop Type',
    ShopInfo: 'Shop Info',
    ShopDetails: 'Shop Details',
    NoData: 'No Data',
    Description: 'Description',
    ContractHistory: 'Contract History',
    RentPyamentHistory: 'Rent Pyament History',
    ElectricityPaymenyHistory: 'Electricity Paymeny History',
    History: 'History',
    Done: 'Done',
    Edit: 'Edit',
    Report: {
      ReportSummary: 'Report Summary',
      HasContract: 'Has Contract',
      WithoutElectricMeter: 'Without Electric Meter',
      HasElectricMeter: ' Has Electric Meter',
      Total: ' Total',

      TotalByStatus: ' Total By Status',
      TotalByType: ' Total By Type',
      GrandTotal: 'Grand Total',
    },
  },
  //#endregion

  //#region ShopReport
  ShopReport: {
    Title: 'ShopReport: List',
    CreateTitle: 'ShopReport: Create New',
    ShopReportList: 'ShopReport List',
    Report: 'Shop Report',
    No: 'No',
    Floor: 'Floor',
    Block: 'Block',
    ShopCode: 'Shop Code',
    ElectricBox: 'Electric Box',
    ElectricMeter: 'Electric Meter',
    Status: 'Shop Status',
    ShopType: 'Shop Type',
    ShopWidth: 'Shop Width',
    ShopLength: 'Shop Length',
    RentPerMonth: 'Rent Per Month',
    RentCurrency: 'Rent Currency',
    ElectricMeterSerial: 'Electric Meter Serial',
    ShopTypeName: 'Shop Type Name',
    BlockName: 'Block Name',
    ShopStatusName: 'Shop Status',
    ShopTypeNameAlt: 'Shop Type',
    Filter: 'Filter',
  },
  //#endregion

  //#region Customer
  Customer: {
    Title: 'Customer: List',
    CreateTitle: 'Customer: Create New',
    CustomerList: 'Customer List',
    Customer: 'Customer',
    Placeholder: 'Search Customer',
    NewCustomer: 'New Customer',
    UpdateCustomer: 'Update Customer',
    CreateCustomer: 'Create Customer',
    Name: 'Name',
    CustomerName: 'Customer Name',
    SurName: 'Surname',
    CustomerGeneralInfo: 'Customer General Info',
    PashtoDariBioData: 'Pashto Dari Bio Data',
    EnglishBioData: 'English Bio Data',
    EnglishFirstName: 'English First Name',
    PashtoDariName: 'Pashto Dari First Name',
    EnglishSurName: 'English Surname',
    PashtoDariSurName: 'Pashto Dari SurName',
    EnglishFatherName: 'English Father Name',
    PashtoDariFatherName: 'Pashto Dari Father Name',
    EnglishGrandFatherName: 'English Grandfather Name',
    PashtoDariGrandFatherName: 'Pashto Dari Grand Father Name',
    FatherName: 'Father Name',
    GrandFatherName: 'Grand Father Name',
    Gender: 'Gender',
    TazkiraType: 'Tazkira Type',
    ETazkira: 'ETazkira',
    PaperBaseTazkira: 'Paper Base Tazkira',
    TazkiraNo: 'Tazkira Number',
    JoldNo: 'Jold Number',
    CNIC: 'CNIC',
    PageNo: 'Page Number',
    RegNo: 'Registration Number',
    DateOfBirth: 'Date of Birth',
    TemporaryAddress: 'Temporary Address',
    PermanentAddress: 'Permanent Address',
    Branch: 'Branch',
    BloodGroup: 'Blood Group',
    Email: 'Email',
    LeaveRemark: 'Leave Remark',
    PersonalEmail: 'Personal Email',
    PhoneNumber: 'Phone Number',
    EmergencyPhoneNumber: 'Emergency Phone Number',
    IsActive: 'Is Active',
    ProfilePhoto: 'Profile Photo',
    PhotoPath: 'Photo Path',
    BranchName: 'Branch Name',
    Province: 'Province',
    ProvinceName: 'Province Name',
    DistrictName: 'District Name',
    District: 'District',
    AfterSubmit: 'After Submit',
    CurrentProvince: 'Current Province',
    CurrentProvinceName: 'Current Province Name',
    CurrentDistrict: 'Current District',
    CurrentDistrictName: 'Current District Name',
    MainProvince: 'Main Province',
    MainProvinceName: 'Main Province Name',
    MainDistrict: 'Main District',
    MainDistrictName: 'Main District Name',
    CropImage: 'Crop Image',
    CustomerDetails: 'Customer Details',
    CustomerGeneralInfos: 'Customer General Info',
    NoData: 'No Data',
    isActive: 'isActive',
    TazkiraInfo: 'Tazkira Info',
    ResidentialAddressInfo: 'Residential Address Info',
  },
  //#endregion

  //#region TermAndCondition
  TermAndCondition: {
    Title: 'Contract Forms List',
    CreateTitle: 'Contract Froms Create New',
    UpdateTitle: 'Contract Froms Update ',
    TermAndConditionList: 'Contract Froms List',
    TermAndCondition: 'Contract Froms',
    Placeholder: 'Search Contract Froms',
    NewTermAndCondition: 'New Contract Froms',
    FormType: 'Form Types',
  },
  //#endregion
  //#region Income
  IncomeCategory: {
    Title: 'Income Category List',
    CreateIncomeCategory: 'Income Category Create New',
    UpdateIncomeCategory: 'Income Category Update ',
    IncomeCategoryList: 'Income Category List',
    IncomeCategory: 'IncomeCategory',
    Placeholder: 'Search Income Category',
    NewIncomeCategory: 'New Income Category',
  },
  //#endregion
  //#region Income
  Income: {
    Title: 'Income  List',
    CreateIncome: 'Income  Create New',
    UpdateIncome: 'Income  Update ',
    IncomeList: 'Income  List',
    IncomeDetails: 'Income  Details',
    Income: 'Income',
    Placeholder: 'Search Income',
    NewIncome: 'New Income',
    Currency: 'Currency',
    Amount: 'Amount',
    Date: 'Date',
    FromDate: 'From Date',
    ToDate: 'ToDate',
    Description: 'Description',
    Print: 'Print',
  },
  //#endregion

  //#region FinancialPayment
  FinancialPayment: {
    Title: 'FinancialPayment  List',
    CreateFinancialPayment: 'FinancialPayment  Create New',
    UpdateFinancialPayment: 'FinancialPayment  Update ',
    FinancialPaymentList: 'FinancialPayment  List',
    FinancialPaymentDetails: 'FinancialPayment  Details',
    FinancialPayment: 'FinancialPayment',
    Placeholder: 'Search FinancialPayment',
    NewFinancialPayment: 'New FinancialPayment',
    Currency: 'Currency',
    Amount: 'Amount',
    Date: 'Date',
    FromDate: 'From Date',
    ToDate: 'ToDate',
    Description: 'Description',
    Print: 'Print',
  },
  //#endregion

  IncomeReport: {
    Title: 'IncomeReport: List',
    IncomeReportTitle: 'Income Report',
    IncomeReportList: 'IncomeReport List',
    Report: 'IncomeReport Report',
    No: 'No',
    Filter: 'Filter',
  },
  //#endregion

  app: `app`,
  user: `user`,
  edit: `edit`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level_1: `menu level 1`,
  menu_level_2: `menu level 2`,
  menu_level_3: `menu level 3`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  report: 'Report',
  NoRecordFound: 'No Record Found',
  categorys: 'Categorys',
  propertyConditions: 'property Conditions',
  //choqorak
  estates: 'Estates',
  setting: 'Setting',
  block: 'Block',
  floor: 'Floor',
  electricBox: 'ElectricBox',
  electricMeter: 'ElectricMeter',
  shopType: 'ShopType',
  status: 'Status',
  shops: 'Shop',
  reports: 'Report',
  contract: 'Contract',
  termsAndCondition: 'TermsAndCondition',
  contractTypes: 'ContractType',
  customerInfo: 'CustomerInfo',
  customer: 'Customer',
  customerReport: 'CustomerReport',
  contractInfo: 'All Contract',
  approved: 'Approved',
  unapproved: 'Need Approval',
  aboutexpired: 'About Expired',
  expired: 'Expired',
  terminated: 'Terminated',
  contractReport: 'ContractReport',
  finance: 'Finance',
  rentPaymentInfo: 'RentPaymentInfo',
  rentPayment: 'RentPayment',
  rentPaymentReport: 'RentPaymentReport',
  electricityPaymentInfo: 'ElectricityPaymentInfo',
  electricPayment: 'ElectricPayment',
  electricityReport: 'ElectricityReport',
  incomes: 'Incomes',
  incomeCollecting: 'IncomeCollecting',
  incomeCategory: 'IncomeCategory',
  incomeReport: 'IncomeReport',
  map: 'Map',
  activeContract: 'Active Contract',
  financialPayments: 'Financial Payment',
};

export default en;
